import { CourseHistory } from "../../components";

export const PersonalCourseHistory = () => {
  return (
    <>
      <CourseHistory isAdmin={false} />
    </>
  );
};
